let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("935eB"), load("l2zt0"), load("04gC2")]).then(() => parcelRequire('lqtku'));